import * as actions from "./../actions/actionTypes";

const initState = {
	token: null,
	isAuth: false,
  userType: null
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.SET_TOKEN:
      return {
      	...state,
      	token: action.payload
      };
      
    case actions.SET_AUTH:
      return {
      	...state,
      	isAuth: action.payload
      };

    case actions.SET_USERTYPE:
      return {
        ...state,
        userType: action.payload
      }

    default:
      return state;
};
}
export default authReducer;
